// extracted by mini-css-extract-plugin
export default {"dot":"UiDotLoader_dot_sW8eb","dotLoader":"UiDotLoader_dotLoader_KCuOg"};